import * as types from '@portal/common/store/session/types';
import { OrganizationMember } from '@portal/common/types';

type Action = {
    type: keyof typeof types;
    payload: any;
};

type State = {
    token: null | string;
    expires: null | string;
    account: null | OrganizationMember;
};

const initialState: State = {
    token: null,
    expires: null,
    account: null,
};

export default function (state: State = initialState, action: Action) {
    switch (action.type) {
        case types.SESSION_SIGNED_IN:
            return {
                ...state,
                ...action.payload,
            };

        case types.SESSION_ACCOUNT_UPDATED:
        case types.SESSION_ACCOUNT_LOADED:
        case types.SESSION_ACCOUNT_PASSWORD_CHANGED:
            return {
                ...state,
                account: action.payload,
            };

        case types.SESSION_SIGNED_OUT:
            return initialState;

        default:
            return state;
    }
}
